import { render, staticRenderFns } from "./TotalArrangemetTable.vue?vue&type=template&id=c8aca07e"
import script from "./TotalArrangemetTable.vue?vue&type=script&lang=js"
export * from "./TotalArrangemetTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports